module.exports = __webpack_public_path__ + "img/jingicom.d0289dc0.png";